import {
  dplParamsKey,
  type ParameterCollection
} from 'job-lib/types/Parameters'

export const isDPLParameterCollection = (
  componentParameters: ParameterCollection
) => componentParameters?.[2]?.name === dplParamsKey
